module.exports = __webpack_public_path__ + "static/work_NOTD_loop-60a5d1f0054bbe5e5092db90416fd847.mp4";